import component from "./BankPayout.vue";
import { listField, formFields } from "./config";

export default {
  component,
  listField,
  formFields,
};

export const selector = (selectedPayoutSystem: string | null): boolean => {
  return selectedPayoutSystem === "bank";
};
